<script setup lang="ts">
import type { DynamicDialogInstance } from "primevue/dynamicdialogoptions";

const dialogRef = inject<ComputedRef<DynamicDialogInstance>>("dialogRef");

defineProps({
  title: {
    type: String,
    default: "",
  },
  subTitle: {
    type: String,
    default: "",
  },
});
</script>

<template>
  <div class="m-auto px-10 py-14 lg:w-[650px]">
    <font-awesome-icon
      :icon="['fas', 'x']"
      class="absolute right-4 top-4 cursor-pointer"
      @click="dialogRef?.close()"
    />
    <div v-if="title || subTitle" class="mb-5 text-center">
      <div v-if="title" class="text-center text-3xl font-bold">
        {{ title }}
      </div>
      <div v-if="subTitle" class="mt-2 text-center text-lg text-surface-300">
        {{ subTitle }}
      </div>
    </div>
    <slot />
  </div>
</template>

<style scoped></style>
